export default "__VITE_ASSET__Cfr41xWG__"